import React from 'react';
import Link from "../../../components/pages/form/Link/Link";

const LinkPage = () => {
    return <Link />
};

export default LinkPage;
